import { useState, useEffect } from "react";
import { fetchWrapper } from "@/helpers/fetch-wrapper";

import { Sheet } from "react-modal-sheet";
import { Box, Grid, TextField, Typography, InputAdornment } from "@mui/material";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import PhoneIcon from "@mui/icons-material/Phone";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import HomeIcon from "@mui/icons-material/Home";

import NotificationSheet from "@/components/NotificationSheet";

import { useThemeMode } from "@/contexts/ThemeContext"; 

const ChangePersonalDetailsSheet = ({ open, onClose, loading = false, details }) => {
     const { isDarkMode } = useThemeMode(); 

	const [isOpen, setIsOpen] = useState(false);
	const [notificationTitle, setNotificationTitle] = useState("");
	const [notificationMessage, setNotificationMessage] = useState("");
	const [notificationType, setNotificationType] = useState("warning");

	const [firstName, setFirstName] = useState(details.firstName || "");
	const [lastName, setLastName] = useState(details.lastName || "");
	const [phoneNumber, setPhoneNumber] = useState(details.phoneNumber || "");
	const [cnp, setCnp] = useState(details.cnp || "");
	const [mailingStreet, setMailingStreet] = useState(details.mailingStreet || "");

	const handleSaveDetails = async () => {
		if (!firstName || !lastName || !phoneNumber || !cnp || !mailingStreet) {
			setNotificationTitle("Câmpuri incomplete");
			setNotificationMessage("Toate câmpurile sunt obligatorii.");
			setIsOpen(true);
			return;
		}

		const resp = await fetchWrapper.post("/api/users/mobile/account", {
			firstName,
			lastName,
			phoneNumber,
			cnp,
			mailingStreet,
		});

		if (resp.success) {
			setNotificationType("success");
			setNotificationTitle("Success!");
			setNotificationMessage("Datele au fost actualizate cu succes.");
			setIsOpen(true);
			setTimeout(() => {
				setIsOpen(false);
				window.location.href = "/";
			}, 2000);
		} else {
			setNotificationType("error");
			setNotificationTitle("Oops");
			setNotificationMessage(resp.error);
			setIsOpen(true);
		}
	};

	return (
		<>
			<Sheet isOpen={open} onClose={onClose} snapPoints={[1]}>
				<Sheet.Container
					className={"sheet-bg " + (isDarkMode ? "dark" : "")}
					style={{
						borderTopLeftRadius: "0",
						borderTopRightRadius: "0",
						height: "100vh",
						maxHeight: "100vh",
						padding: "24px",
						boxSizing: "border-box",
					}}>
					<Sheet.Header />
					<Sheet.Content style={{ display: "flex", flexDirection: "column", height: "100%" }}>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								marginBottom: "32px",
							}}>
							<div style={{ display: "flex", alignItems: "center" }}>
								<button
									onClick={onClose}
									style={{
										background: "none",
										border: "none",
										padding: 0,
										marginRight: 12,
										cursor: "pointer",
									}}>
									<ArrowBackIosNewIcon
										style={{ fontSize: 20, color: isDarkMode ? "#fff" : "#000" }}
									/>
								</button>
								<h2
									style={{
										margin: 0,
										fontSize: "20px",
										fontWeight: "600",
										color: isDarkMode ? "#fff" : "#000",
									}}>
									Detalii personale
								</h2>
							</div>

							<button
								onClick={handleSaveDetails}
								disabled={loading}
								style={{
									background: "none",
									border: "none",
									color: "#F0A500",
									fontSize: "16px",
									fontWeight: "500",
									cursor: "pointer",
									padding: 0,
								}}>
								{loading ? "Se salvează..." : "Salvează"}
							</button>
						</div>

						<Box className='glass-box' sx={{ flexGrow: 1 }}>
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<Typography component='label'>Prenume</Typography>
									<TextField
										value={firstName}
										onChange={(e) => setFirstName(e.target.value)}
										fullWidth
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<PersonIcon />
												</InputAdornment>
											),
										}}
									/>
								</Grid>

								<Grid item xs={12}>
									<Typography component='label'>Nume</Typography>
									<TextField
										value={lastName}
										onChange={(e) => setLastName(e.target.value)}
										fullWidth
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<BadgeIcon />
												</InputAdornment>
											),
										}}
									/>
								</Grid>

								<Grid item xs={12}>
									<Typography component='label'>Număr de telefon</Typography>
									<TextField
										value={phoneNumber}
										onChange={(e) => setPhoneNumber(e.target.value)}
										fullWidth
										type='tel'
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<PhoneIcon />
												</InputAdornment>
											),
										}}
									/>
								</Grid>

								<Grid item xs={12}>
									<Typography component='label'>CNP</Typography>
									<TextField
										value={cnp}
										onChange={(e) => setCnp(e.target.value)}
										fullWidth
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<CreditCardIcon />
												</InputAdornment>
											),
										}}
									/>
								</Grid>

								<Grid item xs={12}>
									<Typography component='label'>Adresă de corespondență</Typography>
									<TextField
										value={mailingStreet}
										onChange={(e) => setMailingStreet(e.target.value)}
										fullWidth
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<HomeIcon />
												</InputAdornment>
											),
										}}
									/>
								</Grid>
							</Grid>
						</Box>
					</Sheet.Content>
				</Sheet.Container>
				<Sheet.Backdrop />
			</Sheet>

			<NotificationSheet
				open={isOpen}
				onClose={() => setIsOpen(false)}
				type={notificationType}
				title={notificationTitle}
				message={notificationMessage}
				confirmText='Închide'
				withCancel={false}
				onConfirm={() => setIsOpen(false)}
				imageUrl={""}
			/>
		</>
	);
};

export default ChangePersonalDetailsSheet;
